'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseChannelMessageMetadata = exports.OpenChannelMessageMetadata = exports.LastSeenMessageMetadata = exports.BlockMessageMetadata = exports.OfflineMessageMetadata = exports.InitialMessageMetadata = exports.ChatMessageMetadata = undefined;

var _Record3, _Record4;

var _immutable = require('immutable');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function makeChatMetadataRecord(type, name) {
  var _Record;

  return (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _PubNubMessageTypes.MESSAGE_TYPE_ID, type), _defineProperty(_Record, 'from', null), _defineProperty(_Record, 'text', null), _defineProperty(_Record, 'welcomeMessageId', null), _defineProperty(_Record, 'richText', null), _defineProperty(_Record, 'url', null), _defineProperty(_Record, 'quickReply', null), _Record), name);
}

var ChatMessageMetadata = exports.ChatMessageMetadata = makeChatMetadataRecord(_PubNubMessageTypes.CHAT_MESSAGE, 'ChatMessageMetadata');

var InitialMessageMetadata = exports.InitialMessageMetadata = makeChatMetadataRecord(_PubNubMessageTypes.INITIAL_MESSAGE, 'InitialMessageMetadata');

var OfflineMessageMetadata = exports.OfflineMessageMetadata = makeChatMetadataRecord(_PubNubMessageTypes.OFFLINE, 'OfflineMessageMetadata');

var BlockMessageMetadata = exports.BlockMessageMetadata = (0, _immutable.Record)(_defineProperty({}, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.BLOCK), 'BlockMessageMetadata');

var LastSeenMessageMetadata = exports.LastSeenMessageMetadata = (0, _immutable.Record)((_Record3 = {}, _defineProperty(_Record3, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.LAST_SEEN), _defineProperty(_Record3, 'from', null), _Record3), 'LastSeenMessageMetadata');

var OpenChannelMessageMetadata = exports.OpenChannelMessageMetadata = (0, _immutable.Record)((_Record4 = {}, _defineProperty(_Record4, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.OPEN_CHANNEL), _defineProperty(_Record4, 'channel', null), _Record4), 'OpenChannelMessageMetadata');

var CloseChannelMessageMetadata = exports.CloseChannelMessageMetadata = (0, _immutable.Record)(_defineProperty({}, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.CLOSE_CHANNEL), 'CloseChannelMessageMetadata');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/MessageMetadataRecords.js
// module id = 305
// module chunks = 0 1